import React from "react";

/** Inline shimmer bone (uses global `.agce-skel` from trade_new.css). */
export function skel(w = "md") {
  return <span className={`agce-skel agce-skel--${w}`}>&nbsp;</span>;
}

/** Order book side placeholder rows. */
export function FuturesOrderBookSkeleton({ rows = 8 }) {
  return (
    <div className="agcx-ft-ob-skel" role="status" aria-label="Loading order book">
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="agcx-ft-ob-skel__row">
          <span className="agce-skel agcx-ft-ob-skel__cell" />
          <span className="agce-skel agcx-ft-ob-skel__cell" />
          <span className="agce-skel agcx-ft-ob-skel__cell" />
        </div>
      ))}
    </div>
  );
}

function BuySellColumnSkeleton({ side }) {
  return (
    <div className={`agcx-ft-buysell-skel__col agcx-ft-buysell-skel__col--${side}`}>
      <div className="agcx-ft-buysell-skel__avail">
        <span className="agce-skel agcx-ft-buysell-skel__label" />
        <span className="agce-skel agcx-ft-buysell-skel__val" />
      </div>
      <span className="agce-skel agcx-ft-buysell-skel__field" />
      <span className="agce-skel agcx-ft-buysell-skel__field" />
      <span className="agce-skel agcx-ft-buysell-skel__slider" />
      <div className="agcx-ft-buysell-skel__ticks">
        <span className="agce-skel agcx-ft-buysell-skel__tick" />
        <span className="agce-skel agcx-ft-buysell-skel__tick" />
        <span className="agce-skel agcx-ft-buysell-skel__tick" />
        <span className="agce-skel agcx-ft-buysell-skel__tick" />
        <span className="agce-skel agcx-ft-buysell-skel__tick" />
      </div>
      <div className="agcx-ft-buysell-skel__avail">
        <span className="agce-skel agcx-ft-buysell-skel__label" />
        <span className="agce-skel agcx-ft-buysell-skel__val" />
      </div>
      <div className="agcx-ft-buysell-skel__avail">
        <span className="agce-skel agcx-ft-buysell-skel__label" />
        <span className="agce-skel agcx-ft-buysell-skel__val" />
      </div>
      <div className="agcx-ft-buysell-skel__avail">
        <span className="agce-skel agcx-ft-buysell-skel__label" />
        <span className="agce-skel agcx-ft-buysell-skel__val" />
      </div>
      <span className="agce-skel agcx-ft-buysell-skel__check" />
      <span className={`agce-skel agcx-ft-buysell-skel__cta agcx-ft-buysell-skel__cta--${side}`} />
    </div>
  );
}

/**
 * Mirrors the futures buy/sell panel: leverage/mode row → order-type tabs →
 * Buy | Sell columns with fields, slider, meta rows, and action buttons.
 */
export function FuturesBuySellSkeleton() {
  return (
    <div className="agcx-ft-buysell-skel" role="status" aria-label="Loading trade form">
      <div className="agcx-ft-buysell-skel__top">
        <span className="agce-skel agcx-ft-buysell-skel__chip" />
        <span className="agce-skel agcx-ft-buysell-skel__chip" />
      </div>

      <div className="agcx-ft-buysell-skel__modes">
        <span className="agce-skel agcx-ft-buysell-skel__mode" />
        <span className="agce-skel agcx-ft-buysell-skel__mode" />
        <span className="agce-skel agcx-ft-buysell-skel__mode" />
        <span className="agce-skel agcx-ft-buysell-skel__info" />
      </div>

      <div className="agcx-ft-buysell-skel__split">
        <BuySellColumnSkeleton side="buy" />
        <BuySellColumnSkeleton side="sell" />
      </div>

      <div className="agcx-ft-buysell-skel__fee">
        <span className="agce-skel agcx-ft-buysell-skel__fee-line" />
      </div>
    </div>
  );
}

/** Account rail skeleton. */
export function FuturesAccountSkeleton() {
  return (
    <div className="agce-ft-acct-panel agcx-ft-acct-skel" role="status" aria-label="Loading account">
      <div className="agce-ft-acct-head">
        <span className="agce-skel agcx-ft-acct-skel__title" />
      </div>
      <div className="agce-ft-acct-section">
        <span className="agce-skel agcx-ft-acct-skel__section-title" />
        <div className="agcx-ft-acct-skel__row">
          <span className="agce-skel agcx-ft-acct-skel__label" />
          <span className="agce-skel agcx-ft-acct-skel__val" />
        </div>
        <div className="agcx-ft-acct-skel__row">
          <span className="agce-skel agcx-ft-acct-skel__label" />
          <span className="agce-skel agcx-ft-acct-skel__val" />
        </div>
        <div className="agcx-ft-acct-skel__row">
          <span className="agce-skel agcx-ft-acct-skel__label" />
          <span className="agce-skel agcx-ft-acct-skel__val" />
        </div>
      </div>
      <div className="agce-ft-acct-section">
        <span className="agce-skel agcx-ft-acct-skel__section-title" />
        <div className="agcx-ft-acct-skel__row">
          <span className="agce-skel agcx-ft-acct-skel__label" />
          <span className="agce-skel agcx-ft-acct-skel__val" />
        </div>
        <div className="agcx-ft-acct-skel__row">
          <span className="agce-skel agcx-ft-acct-skel__label" />
          <span className="agce-skel agcx-ft-acct-skel__val" />
        </div>
      </div>
      <div className="agcx-ft-acct-skel__actions">
        <span className="agce-skel agcx-ft-acct-skel__action" />
        <span className="agce-skel agcx-ft-acct-skel__action" />
        <span className="agce-skel agcx-ft-acct-skel__action" />
      </div>
    </div>
  );
}
